module.exports = __webpack_public_path__ + "img/heedi_homepage_logo_red_solo.37ebac85.png";